import { EntitySkeleton as EntitySkeletonComponent } from '../../../skeleton';
import styles from '../../card.module.css';
import HorizontalScroll from '../HorizontalScroll';

const EntitySkeleton = () => (
  <HorizontalScroll
    className={styles['card-horizontal-scroll']}
    items={Array.from({ length: 5 }).map((_, index) => ({
      children: <EntitySkeletonComponent />,
      key: `skeleton-item-${index}`,
    }))}
  />
);

export default EntitySkeleton;
